<div class="page-header" [ngClass.lt-sm]="{'page-header-mobile': true}"></div>
